// extracted by mini-css-extract-plugin
module.exports = {"energy":"EnergyLayout_energy__g80cn"};